<script>
  import { setContext } from "svelte";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { newsletterKeys } from "$lib/utilities/formFields";
  import { Checkbox, Rule, CenteredLayout } from "@ObamaFoundation/of-design-system";
  import Form from "$lib/contentTypes/Form.svelte";
  import { selectedNewsletters } from "$lib/stores";

  export let data;
  export let result = {};
  export let preSelectedNewsletters;
  let canSubmit = false;

  let containerRef;

  let newsletterOptions = data.fields.optionsToInclude.map((x) => {
    const newsletter = newsletterKeys[x];
    const description = data.fields[newsletter.descriptionField]?.trim();

    if (!description) {
      return newsletter;
    }

    return {
      ...newsletter,
      fieldProps: { ...newsletter.fieldProps, fieldDetailsRichText: description }
    };
  });

  /* Initialize the store to have a key representing each option and a value
    representing whether it's been selected. */
  let newsletterStore = {};
  newsletterOptions.forEach((option) => {
    newsletterStore[option.fieldProps.id] = false;
  });
  if (preSelectedNewsletters) {
    newsletterStore = preSelectedNewsletters;
  }

  selectedNewsletters.set(newsletterStore);

  const verifyAtLeastOneSelected = (option) => option;

  let formSubmitErrorMessage = "";

  const handleSubmit = () => {
    canSubmit = Object.values($selectedNewsletters).find(verifyAtLeastOneSelected);
    formSubmitErrorMessage = canSubmit ? "" : data.fields.errorMsgNoneSelected;
  };

  const handleChange = (checkbox) => {
    const { detail } = checkbox;

    if (detail) {
      if (detail.id === "newsletters-select-all") {
        // Select or de-select all options.
        selectedNewsletters.update((state) => {
          Object.keys($selectedNewsletters).forEach((id) => {
            state[id] = detail.value;
          });
          return state;
        });
      } else {
        selectedNewsletters.update((state) => {
          // If select-all is checked and we unselect one option, also unselect select-all option.
          if (!detail.value && $selectedNewsletters["newsletters-select-all"]) {
            state["newsletters-select-all"] = false;
          }

          state[detail.id] = state[detail.id] === false;

          // Return true if all newsletters selected or are the select-all option.
          let allSelected = () =>
            Object.keys($selectedNewsletters).every(
              (selection) =>
                $selectedNewsletters[selection] || selection === "newsletters-select-all"
            );

          // If all options are selected, make sure select-all is selected.
          if (detail.value && !$selectedNewsletters["newsletters-select-all"] && allSelected()) {
            state["newsletters-select-all"] = detail.value;
          }
          return state;
        });
      }
    }
    canSubmit = Object.values($selectedNewsletters).find(verifyAtLeastOneSelected);
    formSubmitErrorMessage = "";
  };

  // If successfully registered, focus page at the top to display success message.
  $: if (result.status === "success") {
    setTimeout(() => {
      window.scrollTo({
        top: containerRef?.offsetTop || 0,
        behavior: "smooth"
      });
    }, 10);
  }

  $: setContext("selectedNewsletters", $selectedNewsletters);

  let submitSuccessCampaignsSelected = [];
  $: submitSuccessCampaignsSelected = newsletterOptions.filter(
    // Filter for selected campaigns
    (newsletter) => {
      return (
        $selectedNewsletters[newsletter.fieldProps.name] &&
        newsletter.fieldProps.name !== "newsletters-select-all"
      );
    }
  );

  setContext("containerized", true);
</script>

<CenteredLayout aria-live="polite">
  {#if result?.status !== "success"}
    <div class="">
      {#each newsletterOptions as field}
        <Checkbox
          id={field.fieldProps.id}
          label={field.fieldProps.label}
          required={field.fieldProps.required}
          isChecked={$selectedNewsletters[field.fieldProps.id]}
          on:change={handleChange}
        />
        {#if field.fieldProps.fieldDetailsRichText}
          <p class="font-['chronicle-text'] body-md mt-6">
            {field.fieldProps.fieldDetailsRichText}
          </p>
        {/if}
        <Rule type="thin" theme="white" class="my-15 w-full" />
      {/each}
    </div>
  {:else}
    {#each submitSuccessCampaignsSelected as campaign}
      <div bind:this={containerRef}>
        <Checkbox
          id={campaign.fieldProps.id}
          label={campaign.fieldProps.label}
          disabled={true}
          isChecked={true}
        />
      </div>
      {#if campaign.fieldProps.fieldDetailsRichText}
        <p class="font-['chronicle-text'] body-md mt-6">
          {campaign.fieldProps.fieldDetailsRichText}
        </p>
      {/if}
      <Rule type="thin" theme="white" class="my-15 w-full" />
    {/each}
  {/if}
  <Form
    on:submit={handleSubmit}
    data={data.fields.emailSignUpForm}
    {canSubmit}
    {formSubmitErrorMessage}
    bind:result
  />
</CenteredLayout>
